import { Label } from '@customerio/pluma-components/react';
import type { ServicesApiBackfillState } from '@/services/api/services-api';

const STATE_LABELS: Record<ServicesApiBackfillState, string> = {
  Queued: 'Queued',
  InProgress: 'In Progress',
  Failure: 'Failure',
  Success: 'Success',
  Retrying: 'Retrying',
  Canceled: 'Canceled',
};

const STATE_LABEL_COLORS: Record<ServicesApiBackfillState, 'grey' | 'blue' | 'red' | 'yellow' | 'green'> = {
  Queued: 'grey',
  InProgress: 'yellow',
  Failure: 'red',
  Success: 'green',
  Retrying: 'yellow',
  Canceled: 'grey',
};

export interface TaskStateBadgeProps {
  state: ServicesApiBackfillState;
}

export function TaskStateBadge({ state }: TaskStateBadgeProps) {
  const color = STATE_LABEL_COLORS[state];
  const label = STATE_LABELS[state];

  return <Label color={color}>{label}</Label>;
}
